import apiClient from './apiClient';

/**
 * Solicita un código para restablecer la contraseña
 * @param {string} email - Email del usuario
 * @returns {Promise} - Respuesta del servidor
 */
export const requestPasswordReset = async (email) => {
  try {
    const response = await apiClient.post('/auth/request-password-reset/', { email });
    return response.data;
  } catch (error) {
    console.error('Error al solicitar restablecimiento de contraseña:', error);
    throw error;
  }
};

/**
 * Verifica el código y establece una nueva contraseña
 * @param {Object} data - Datos para verificación y nueva contraseña
 * @param {string} data.email - Email del usuario
 * @param {string} data.code - Código de verificación
 * @param {string} data.new_password - Nueva contraseña
 * @returns {Promise} - Respuesta del servidor con tokens de acceso
 */
export const verifyPasswordReset = async (data) => {
  try {
    const response = await apiClient.post('/auth/verify-password-reset/', data);
    return response.data;
  } catch (error) {
    console.error('Error al verificar código de restablecimiento:', error);
    throw error;
  }
};